import * as React from 'react';

import { H5, H6 } from '@blueprintjs/core';

interface QuickLinkSectionProps extends React.PropsWithChildren<{}> {
  subtitle?: string;
  title: string;
}

const QuickLinkSection: React.FC<QuickLinkSectionProps> = ({
  title,
  subtitle,
  children,
}) => (
  <nav>
    <H5>{title}</H5>
    {subtitle && <H6>{subtitle}</H6>}
    {children}
  </nav>
);

export default QuickLinkSection;
